// extracted by mini-css-extract-plugin
module.exports = {"subheader":"sfQIDM6J-z+pslBYf8xLfw=="};